import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    hideDelay: { type: Number, default: 4000 },
  }
  static classes = ['show']

  connect() {
    this.show()
  }

  disconnect() {
    this.hide()
  }

  show() {
    this.element.classList.add(...this.showClasses)
    this.timeout = setTimeout(() => this.hide(), this.hideDelayValue)
  }

  hide() {
    clearTimeout(this.timeout)
    this.element.classList.remove(...this.showClasses)
  }
}
